var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportedFlaggedUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4856 12.0005L9.15231 2.66714C9.03602 2.46194 8.86738 2.29127 8.66359 2.17252C8.45981 2.05378 8.22817 1.99121 7.99231 1.99121C7.75645 1.99121 7.52481 2.05378 7.32103 2.17252C7.11724 2.29127 6.9486 2.46194 6.83231 2.66714L1.49898 12.0005C1.38143 12.204 1.3198 12.4351 1.32032 12.6701C1.32084 12.9052 1.3835 13.136 1.50194 13.339C1.62039 13.5421 1.79041 13.7102 1.99477 13.8264C2.19914 13.9425 2.43058 14.0026 2.66564 14.0005H13.3323C13.5662 14.0002 13.796 13.9385 13.9985 13.8213C14.201 13.7042 14.3691 13.5359 14.486 13.3332C14.6028 13.1306 14.6643 12.9007 14.6643 12.6668C14.6642 12.4329 14.6026 12.2031 14.4856 12.0005Z",
    stroke: "#6B6B6B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6V8.66667",
    stroke: "#6B6B6B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.333H8.00667",
    stroke: "#6B6B6B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportedFlaggedUsers);
export default __webpack_public_path__ + "static/media/reported-flagged-users.6248df738154ba09f9e5181db65eb160.svg";
export { ForwardRef as ReactComponent };